import Axios from 'axios';
import config from '../config/config';

export const UseRegistroPrestador = async (nombre, apellido, dni, email, password, codigo_de_area, celular, zonas, servicios, terminos_y_condiciones) => {
    try {
        const res = await Axios.post(
            `${config.REACT_APP_SERVER}/api/workers`,
            {
                nombre,
                apellido,
                dni,
                email,
                password,
                codigo_de_area,
                celular,
                zonas,
                servicios,
                terminos_y_condiciones
            }
        );

        return res.data;
    } catch (error) {
        console.log(error);
    }
}
export const UseRegistroUsuario = async (nombre, apellido, email, password, terminos_y_condiciones) => {
    console.log("Llegue al servicio.")
    try {
        const res = await Axios.post(
            `${config.REACT_APP_SERVER}/api/users`,
            {
                nombre,
                apellido,
                email,
                password,
                terminos_y_condiciones
            }
        );

        return res.data;
    } catch (error) {
        console.log(error);
    }
}